import cx from "classnames";
import Description from "@/components/shared/Description";

interface ModalHeaderProps {
  className?: string;
  hasBorder?: boolean;
  centerText?: boolean;
  title?: string;
  showClose?: boolean;
  requestClose?: () => void;
  description?: string;
  docsUrl?: string;
  subdescription?: string;
}

const ModalHeader = ({
  className,
  centerText,
  title,
  showClose = true,
  description,
  docsUrl,
  subdescription,
  requestClose
}: ModalHeaderProps) => (
  <div className={cx("Modal-header-compat pb-4", className)}>
    <div className="flex flex-1 min-h-0 justify-between gap-2">
      <h3
        className={cx(
          centerText && "text-center",
          "font-poppins font-semibold text-2xl tracking-normal text-h1"
        )}
      >
        {title}
      </h3>
      {showClose && (
        <button
          type="button"
          data-testid="close-modal-btn"
          aria-label="Close"
          className="flex-none CloseButton-wrapper flex flex-col items-center justify-center border-0 bg-transparent p-0 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4f46e5]"
          onClick={() => requestClose?.()}
        >
          <span className="icon clickable u-closeIcon" aria-hidden="true"></span>
        </button>
      )}
    </div>
    {description && (
      <Description
        text={description}
        docsUrl={docsUrl}
        className="pr-5"
      />
    )}
    {subdescription && (
      <Description text={subdescription} className="pr-5" />
    )}
  </div>
);

export default ModalHeader;
